import * as React from 'react';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Tabs } from 'antd';
import t from 'utils/translations';

import FrontPageArticleList from 'components/common/FrontPageArticleList';
import BasicLayout from 'components/layout/BasicLayout';
import {
    AggregationKeyFigureResponse,
    IndustryInfo,
    KeyFigureData
} from '../../context/types';
import { ArticleListType } from 'components/common/FeedTypes';

import IndustryTab from 'components/pages/frontpage/IndustryTab';
import { CompanyKeyFigureGraphs } from 'components/common/KeyFigureGraph/CompanyKeyFigureGraphs';
import { Feeds, getTitleElement } from 'components/pages/frontpage/common';
import { apiGetIndustryKeyFigureAggregations } from 'api/industries';
import { prepareAggregationsToKeyFigureData } from 'utils/keyfigures';
import { PageHeading, PageWrapper } from 'components/common';

const Content = styled.article``;

const GraphsAndTables = styled.div``;

const SAMPLE_LOWER_LIMIT = 500;

export default function FrontPage() {
    const [keyFigureData, setKeyFigureData] = useState<
        KeyFigureData | undefined
    >(undefined);

    useEffect(() => {
        const industryInfo: IndustryInfo = {
            code: '*',
            label: 'Kaikki yritykset'
        };
        apiGetIndustryKeyFigureAggregations(industryInfo.code)
            .then(res => res.json())
            .then((data: AggregationKeyFigureResponse) =>
                setKeyFigureData(
                    prepareAggregationsToKeyFigureData(
                        data.content,
                        industryInfo.label,
                        SAMPLE_LOWER_LIMIT
                    )
                )
            );
    }, []);

    return (
        <BasicLayout>
            <PageWrapper>
                <PageHeading>{t('DASHBOARD')}</PageHeading>
                <Tabs
                    defaultActiveKey="1"
                    onChange={() => 'hello'}
                    animated={false}
                >
                    <Tabs.TabPane tab={t('DEFAULT_COMPANY_FP')} key="1">
                        <Content>
                            <GraphsAndTables>
                                <CompanyKeyFigureGraphs
                                    showMonths={false}
                                    canCompare={true}
                                    isAggregateData={true}
                                    isLoading={keyFigureData === undefined}
                                    keyFigureData={keyFigureData}
                                    title={getTitleElement(
                                        t('KEY_FIGURES_GRAPH_TITLE_FP'),
                                        t('GRAPH_INFO_LARGE_SAMPLES')
                                    )}
                                    sampleLowerLimit={SAMPLE_LOWER_LIMIT}
                                />
                            </GraphsAndTables>
                            <Feeds>
                                <FrontPageArticleList
                                    title={t('RECENT_NEWS')}
                                    articleListType={ArticleListType.TALENTNEWS}
                                />
                                <FrontPageArticleList
                                    title={t('SOCIAL_MEDIA')}
                                    articleListType={
                                        ArticleListType.SOCIALMEDIA
                                    }
                                />
                            </Feeds>
                        </Content>
                    </Tabs.TabPane>
                    <Tabs.TabPane tab={t('INDUSTRIES_FP')} key="2">
                        <IndustryTab />
                    </Tabs.TabPane>
                </Tabs>
            </PageWrapper>
        </BasicLayout>
    );
}
